import { axios } from '@Root/API'

export const edit = payload => {
	return axios.put('institutions', payload)
}
